// assets/images/index.js
import bmwLogo from './bmw-logo.png';
import bmwGroupLogo from './bmwgroup-logo.png';
import theNext100Years from './thenext100years.png';
import miniLogo from './mini-logo.png';


const images = {
  'bmw-logo.png': bmwLogo,
  'bmwgroup-logo.png': bmwGroupLogo,
  'thenext100years.png': theNext100Years,
  'mini-logo.png': miniLogo
};

export default images;